const ExamQuestion = {
    "exam_question": "Exam Question",
    "exam": "Exam",
    "question_ids": "Questions",
    "error_exam": "Select Exam",
    "error_questions": "Select at least one question",
    "table_question": "QUESTION",
    "table_marks": "MARKS",
    "table_order": "ORDER",
}

export default ExamQuestion;
